import * as v from 'valibot';
import { fieldModelErrors as fErr, txtIsRequired } from '~/constants';
import type { Claim, ClaimInternal, GenericVuetifyListItem } from '~/types';
// import { ClaimStatus, SiteMembershipContext } from '~/types';
import { ClaimStatus } from '~/types';
import { SiteMembershipContext } from '~/types/membership';
import { BaseModel } from '~/models/base-model';
import { FilePondOutputValidationModel } from '~/models/file-upload';


export class ClaimModel extends BaseModel<Claim> {
    claimNo = null;
    status = ClaimStatus.incomplete;
    enteredSerialCode = null;
    matchedSerialCode = null;
    created = null;
    credit = 0;
    purchaseDate = null;
    /**
    *  @deprecated
    */
    description = null;
    noProofExplanation = null;
    playerAge = null;
    useDescription = null;
    damageDescription = null;
    breakLocation = null;
    files = [];
    registrationUid = null;
    skuUid = null;
    freeShipping = null;
    purchasedFrom = null;
    proofOfPurchase = null;
    purchaseType = null;
}

export class ClaimModelInternal extends BaseModel<ClaimInternal> {
    isProductSelector = false;
    productUid = null;
    filesUnprocessed = null;
}

export const ClaimPurchaseFromList: GenericVuetifyListItem[] = [
    {
        title: 'StringKing',
        value: 'stringking'
    },
    {
        title: 'Retail Store',
        value: 'retail_store'
    },
    {
        title: 'Retail Website',
        value: 'retail_website'
    },
    {
        title: 'Event',
        value: 'event'
    }
];


// Validation Models

/*
SelectPurchaseType
SelectProd
PlayerProfile
DamageProofUpload

SelectRegOrProd
SelectSku
ProofOfPurchase
*/


// Select purchase type
export const SelectPurchaseTypeFormModel = v.object({
    purchaseType: v.union([
        v.literal(SiteMembershipContext.Personal),
        v.literal(SiteMembershipContext.Entity)
    ])
});
export type SelectPurchaseTypeFormType = v.InferOutput<typeof SelectPurchaseTypeFormModel>;



// Select product
export const SelectProdFormModel = v.object({
    productUid: v.pipe(
        v.string(),
        v.minLength(1)
    ),
    prodSelectedPath: v.strictTuple([v.string(), v.string(), v.string()])
});
export type SelectProdFormType = v.InferOutput<typeof SelectProdFormModel>;



// Player Profile
export const PlayerProfileFormModel = v.object({
    playerAge: v.pipe(
        v.number(fErr.age),
        v.minValue(8, 'Player Age must be at least 8'),
        v.maxValue(99, 'Player Age must be at most 99')
    ),
    useDescription: v.pipe(
        v.string(`Use Description ${txtIsRequired}`),
        v.minLength(1, fErr.noEmpty)
    ),
    damageDescription: v.pipe(
        v.string(`Damage Description ${txtIsRequired}`),
        v.minLength(1, fErr.noEmpty)
    )
});
export type PlayerProfileFormType = v.InferOutput<typeof PlayerProfileFormModel>;




// Damage proof upload
// const fileErr = `At least 1 file ${txtIsRequired}`;
export const DamageProofUploadFormModel = v.object({
    filesUnprocessed: v.message(FilePondOutputValidationModel, `Damage Proof Upload ${txtIsRequired}`)
});
export type DamageProofUploadFormType = v.InferOutput<typeof DamageProofUploadFormModel>;




// Reg or prod
export const SelectRegOrProdFormModel = v.pipe(
    v.object(
        {
            registrationUid: v.nullable(
                v.string()
            ),
            isProductSelector: v.boolean()
        }
    ), v.check(
        (input) => (!!input.isProductSelector && !input.registrationUid) ||
        (!input.isProductSelector && !!input.registrationUid) &&
        !(!input.isProductSelector && !input.registrationUid)
    )
);
export type SelectRegOrProdFormType = v.InferOutput<typeof SelectRegOrProdFormModel>;



// Proof of purchase
export const ProofOfPurchaseModel = v.variant('hasNoProof', [
    v.object(
        {
            proofOfPurchaseUnprocessed: v.message(FilePondOutputValidationModel, `Purchase Proof Upload ${txtIsRequired}`),
            purchasedFrom: v.optional(
                v.pipe(
                    v.string(`Purchased From ${txtIsRequired}`),
                    v.minLength(1, fErr.noEmpty)
                )
            ),
            purchaseDate: v.pipe(
                v.string(fErr.purchaseDate),
                v.isoDate(fErr.purchaseDate)
            ),

            hasNoProof: v.literal(false)
        }
    ),
    v.object(
        {
            noProofExplanation: v.pipe(
                v.string(`No-Proof Explanation ${txtIsRequired}`),
                v.minLength(1, fErr.noEmpty)
            ),
            hasNoProof: v.literal(true)
        },
        `No-Proof Explanation ${txtIsRequired}`
    )
]);


export type ProofOfPurchaseType = v.InferOutput<typeof ProofOfPurchaseModel>;


export const SelectSkuFormModel = v.object(
    {
        skuUid: v.nullable(
            v.string()
        )
    }
);
export type SelectSkuFormType = v.InferOutput<typeof SelectSkuFormModel>;
